import createIcon from '../../createIcon';

/**
 * @component @name BrokenImage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgNVYxMS41OUwxOCA4LjU4TDE0IDEyLjU5TDEwIDguNTlMNiAxMi41OUwzIDkuNThWNUMzIDMuOSAzLjkgMyA1IDNIMTlDMjAuMSAzIDIxIDMuOSAyMSA1Wk0xOCAxMS40MkwyMSAxNC40M1YxOUMyMSAyMC4xIDIwLjEgMjEgMTkgMjFINUMzLjkgMjEgMyAyMC4xIDMgMTlWMTIuNDJMNiAxNS40MUwxMCAxMS40MUwxNCAxNS40MUwxOCAxMS40MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BrokenImage = createIcon('BrokenImage', [
  [
    'path',
    {
      d: 'M21 5V11.59L18 8.58L14 12.59L10 8.59L6 12.59L3 9.58V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5ZM18 11.42L21 14.43V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V12.42L6 15.41L10 11.41L14 15.41L18 11.42Z',
      key: 'qhexry',
    },
  ],
]);

export default BrokenImage;
